export const REGULAR_CHANGE_PASSWORD_MODAL = 'RegularChangePasswordModal'
export const AUTH_CHANGE_PASSWORD_MODAL = 'AuthChangePasswordModal'
